// 📁 components/categoria/IconHelper.js
// Componente separado para manejar iconos
import React from "react";
import {
  AccountBalance,
  LocationOn,
  Groups,
  Category
} from "@mui/icons-material";
import { getCategoriaIconType } from "../../utils/categoriaHelpers";

// Función que retorna el componente de icono apropiado
export const getCategoriaIcon = (descripcion, size = 24, theme) => {
  const iconType = getCategoriaIconType(descripcion);
  const iconProps = { sx: { fontSize: size, color: theme?.palette?.accent?.main } };
  
  switch (iconType) {
    case "AccountBalance":
      return <AccountBalance {...iconProps} />;
    case "LocationOn":
      return <LocationOn {...iconProps} />;
    case "Groups":
      return <Groups {...iconProps} />;
    case "Category":
    default:
      return <Category {...iconProps} />;
  }
};